// src/pages/TermsOfServicePage.js
import React from 'react';

const TermsOfServicePage = () => {
  return (
    <div className="container my-5">
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> April 6, 2025</p>

      <p>
        Welcome to RxRooster. By accessing or using our services, website, platform, or tools,
        you agree to be bound by the following terms and conditions. If you do not agree with these Terms of Service,
        please do not use our services.
      </p>

      <h5>1. Overview</h5>
      <p>
        RxRooster, a Nevada LLC, provides staffing solutions that connect Certified Registered Nurse Anesthetists (CRNAs)
        with healthcare facilities. These Terms govern your use of our services as either a healthcare facility ("Group")
        or an independent provider ("CRNA").
      </p>

      <h5>2. Eligibility</h5>
      <p>To use RxRooster, you must be:</p>
      <ul>
        <li>At least 18 years of age</li>
        <li>Legally authorized to work in the United States (for CRNAs)</li>
        <li>Authorized to represent a healthcare facility (for Groups)</li>
      </ul>

      <h5>3. Service Nature</h5>
      <p>
        RxRooster provides a platform and services to facilitate introductions between CRNAs and Groups.
        RxRooster is not the employer of any CRNA and does not guarantee placement, availability, or performance.
      </p>

      <h5>4. Fees and Payments</h5>
      <p>
        RxRooster charges flat-rate placement fees for successful CRNA matches. Fees will be outlined in
        individual agreements with Groups. No commissions or percentage of provider wages are taken.
      </p>

      <h5>5. CRNA Engagement</h5>
      <p>
        RxRooster introduces CRNAs to Groups but does not dictate the terms of employment, engagement,
        or contracts. CRNAs and Groups are solely responsible for entering into any contractual relationship
        directly with each other.
      </p>

      <h5>6. Confidentiality</h5>
      <p>
        RxRooster respects the confidentiality of both parties. You agree not to misuse or disclose confidential
        information shared through the platform.
      </p>

      <h5>7. Termination</h5>
      <p>
        Either party may terminate their use of RxRooster services at any time by emailing <a href="mailto:support@rxrooster.com">support@rxrooster.com</a>.
        All accrued obligations, including unpaid fees, remain enforceable.
      </p>

      <h5>8. Limitations of Liability</h5>
      <p>
        RxRooster makes no guarantees regarding successful placements. We are not liable for any damages, direct or indirect,
        resulting from the use of our services or outcomes of CRNA engagements.
      </p>

      <h5>9. Modifications</h5>
      <p>
        We reserve the right to modify these Terms of Service at any time. Continued use of RxRooster after updates
        constitutes acceptance of the new terms.
      </p>

      <h5>10. Contact</h5>
      <p>
        If you have any questions or concerns, please reach out to us at <a href="mailto:support@rxrooster.com">support@rxrooster.com</a>.
      </p>

      <p className="mt-4">Thank you for choosing RxRooster.</p>
    </div>
  );
};

export default TermsOfServicePage;
